import { apiClient } from '@/shared/api';
import { API_ENDPOINTS } from '@/config';
import type {
    GenericResponse,
    SetBlockStatusRequest,
    CancelCardRequest,
    AccountCreateRequest,
    CardActivateRequest,
    GetListCardsParams,
} from '@/features/card/types/card.types';
import { buildCommonHeaders } from '@/shared/http/commonHeaders';
import type { ExportDirective } from '@/shared/export/types';



export const cardService = {
    async blockCard(payload: SetBlockStatusRequest): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.card.block, { data: { data: payload } }, { headers: newHeaders });
        return response.data;
    },

    async unblockCard(payload: SetBlockStatusRequest): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.card.unblock, { data: { data: payload } }, { headers: newHeaders });
        return response.data;
    },

    async cancelCard(uuid: string, params: CancelCardRequest): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        const { ...queryParams } = params;

        return apiClient.post<GenericResponse>(API_ENDPOINTS.account.cancel(uuid), {}, { headers: newHeaders, params: queryParams });
    },

    async accountCreate(payload: AccountCreateRequest): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        return apiClient.post<GenericResponse>(API_ENDPOINTS.account.create, { data: { data: payload } }, { headers: newHeaders });
    },

    async cardActivate(payload: CardActivateRequest): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        return apiClient.post<GenericResponse>(API_ENDPOINTS.card.activate, { data: { data: payload } }, { headers: newHeaders });
    },

    async listCards(params: GetListCardsParams): Promise<any> {
        const newHeaders = buildCommonHeaders({
            withLocation: true
        });

        const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.card.list, {}, { headers: newHeaders, params: params });
        return response.data.data;
    },

    /**
     * Downloads the cards report as a file (BF-613): same list command (filters
     * go as query params) plus an `export` directive in the body.
     */
    async exportCards(params: GetListCardsParams, directive: ExportDirective) {
        const newHeaders = buildCommonHeaders({ withLocation: true });

        return apiClient.download(API_ENDPOINTS.card.list, {
            body: { data: { export: directive } },
            headers: newHeaders,
            params,
        });
    },
};
